<template>
  <li class="menu-item">
    <a href="#" :class="classList" @click.prevent="handleClick"><t-icon :name="iconName"/></a>
    <slot></slot>
  </li>
</template>

<script>
export default {
  data () {
    return {
      localActive: false
    }
  },
  methods: {
    handleClick (e) {
      e.preventDefault()
      this.$emit('click', this.target)
    }
  },
  computed: {
    classList () {
      var classes = ''
      if (this.localActive) {
        classes += ' active'
      }

      return classes
    }
  },
  props: {
    active: {
      type: Boolean,
      default: false
    },
    target: {
      type: String,
      default: ''
    },
    iconName: {
      type: String,
      default: ''
    }
  },
  watch: {
    active (newVal) {
      this.localActive = newVal
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/MenuItem.vue